import { InfoCard } from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';

export const AboutUser = () => {
  const { entity } = useEntity();

  if (!entity.metadata?.annotations?.tz) {
    return <></>;
  }

  const tz = entity.metadata!.annotations!.tz;
  const time = new Date().toLocaleTimeString('en-us', { timeZone: tz });

  return (
    <InfoCard title="Location">
      <p>Timezone: {tz}</p>
      <p>Time: {time}</p>
    </InfoCard>
  );
};
